import Vue from 'vue'

const state = {
    totalIncomes: {
        business_bonus_income: {amount: '-'},
        car_bonus_income: {amount: '-'},
        direct_bonus_career_level_income: {amount: '-'},
        direct_bonus_position_income: {amount: '-'},
        matching_bonus_income: {amount: '-'},
        total_income: {amount: '-'},
        unilevel_bonus_career_level_income: {amount: '-'},
        unilevel_bonus_position_income: {amount: '-'},
    }
}

const getters = {
    totalIncomes: state => {
        return state.totalIncomes
    }
}

const mutations = {
    setTotalIncomes (state, data) {
        Vue.set(state, 'totalIncomes', data)
    }
}

const actions = {}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/totalIncomes.js